import { AppStateEnum } from '../../main/types/app-state.types.ts';

import { SPEECH_RATES } from '../constants/animation-sequence.ts';
import { BallAnimation } from '../slices/ball/ball.slice.types.ts';
import { RenderableStoryLine } from '../types/story-reading.types.ts';
import { StorySentenceBallAnimationPositions } from '../types/story-sentence-animation.types.ts';

import { mapStorySentenceAnimationMultiLine } from './story-sentence-animation-multi-line.mapper.ts';
import { mapStorySentenceAnimationSingleLine } from './story-sentence-animation-single-line.mapper.ts';
import { mapToWordCount } from './story-sentence-animation-word-count.mapper.ts';

interface AnimationMapperProps {
  appState: AppStateEnum;
  animationPositions: StorySentenceBallAnimationPositions;
  lines: RenderableStoryLine[];
}

export const mapStorySentenceAnimationSequence = (props: AnimationMapperProps): BallAnimation[] => {
  const { appState, animationPositions, lines } = props;
  const { startPosition, finalPosition } = animationPositions;

  const msPerWord = appState === AppStateEnum.Recording ? SPEECH_RATES.USER.MS_PER_WORD : SPEECH_RATES.APP.MS_PER_WORD;

  const wordCounts = mapToWordCount(lines, startPosition, finalPosition);

  if (startPosition.line === finalPosition.line) {
    return [mapStorySentenceAnimationSingleLine(startPosition, finalPosition, wordCounts.total * msPerWord)];
  }

  return mapStorySentenceAnimationMultiLine(startPosition, finalPosition, wordCounts, msPerWord, lines);
};
